import React, { FunctionComponent } from 'react';

import { getRegions } from '@/pageGeneration/services/prismicApi/landingPageDestinationsApi';

import BarHeaderLayout from '@/pages/layouts/BarHeaderLayout';

import RegionsIndexPage from '@/components/pageComponents/RegionsIndexPage';
import PageSeo from '@/components/seo/PageSeo';
import packageStaticProps from '@/utility/nextJs/packageStaticProps';
import useCustomPageViews from '@/utility/eventTracking/useCustomPageViews';
import { PAGE_CATEGORIES } from '@/utility/eventTracking/constants';
import UnprotectedPage from '@/components/navigation/UnprotectedPage';
import RouteHelper from '@jetslash/market-frontend-shared-core/src/utilities/navigation/RouteHelper';
import { ILandingPageLink } from '@/pageGeneration/services/LandingPageService';

interface IProps {
  items: ILandingPageLink[];
}

const AirportRegions: FunctionComponent<IProps> = ({ items }) => {
  useCustomPageViews({ category: PAGE_CATEGORIES.AIRPORT, name: 'List' });

  const title = 'Airports';
  return (
    <UnprotectedPage>
      <PageSeo title={title} noIndex />
      <BarHeaderLayout>
        <RegionsIndexPage title={title} items={items} />
      </BarHeaderLayout>
    </UnprotectedPage>
  );
};

export default AirportRegions;

export async function getStaticProps(): Promise<any> {
  let items: ILandingPageLink[];
  try {
    const results = await getRegions();

    items = results.map((item) => ({
      title: item.data.name,
      slug: item.uid,
      url: RouteHelper.airportRegionPath(item.uid),
    }));

    return packageStaticProps({
      items,
    });
  } catch (e) {
    return {
      notFound: true,
    };
  }
}
